import theme from 'config/theme';

export default {
  textfield: {
    width: '100%',
    borderRadius: '4px',
    boxShadow: 'none',
    height: '40px',

    '& .MuiInputBase-input': {
      padding: '10px 12px',
      color: theme.palette.grays.gray700,
    },
    '& .MuiInputBase-root': {
      borderRadius: '4px',
      fontSize: '0.875rem',
      width: '100%',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.grays.gray300}`,
      },
      '&:hover': {
        backgroundColor: `${theme.palette.grays.lightestGray}`,

        '.MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          color: theme.palette.grays.gray700,
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
      '&.Mui-focused': {
        '.MuiOutlinedInput-notchedOutline': {
          border: 1,
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
      '&.Mui-disabled': {
        opacity: 0.8,
        backgroundColor: `transparent`,
        '& .MuiInputBase-input': {
          backgroundColor: `transparent`,
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.grays.gray300}`,
        },
      },
    },
  },
  errorTextInput: {
    '& .MuiInputBase-root': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.error.main}`,
      },
      '&:hover': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.error.main}`,
        },
        '& .MuiInputBase-input': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
    },
  },
  popper: {
    '& .MuiPaper-root': {
      borderRadius: '8px',
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    },
  },
};
